import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ListWholesaler } from "./listofWholesaler";
import { IoIosArrowBack } from "react-icons/io";
import { MdOutlineDriveFolderUpload } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string, boolean } from "yup";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import NoImageFound from "../../assets/images/No-Image-found.png";
import Select from "react-select";

const validationSchema = object().shape({
  first_name: string().required("First Name is required"),
  alternative_contact_number: string()
    .matches(/^\d{10}$/, "Must be exactly 10 digits")
    .required("Alternative contact number is required"),
  email: string().email("Invalid email").required("Email is required"),
  business_name: string().required("Business Name is required"),
  door_no: string().required("Door No is required"),
  street: string().required("Street is required"),
  area: string().required("Area is required"),
  city: string().required("City is required"),
  state: string().required("State is required"),
  pincode: string().required("Pincode is required"),
  ryder_zone: string().required("Ryder Zone is required"),
  // bank_name: string().required("Bank Name is required"),
  // bank_account_number: string().required("Bank Account Number is required"),
  // ifsc_code: string().required("ifsc code is required"),
  // razorpay_account_id: string().required("razorpay account id is required"),
  // beneficiary_name: string().required("beneficiary name is required"),
  // outlet_verified: boolean().oneOf(
  //   [true],
  //   "Please verify the business outlet image"
  // ),
  bank_name: string(),
  bank_account_number: string(),
  ifsc_code: string(),
  beneficiary_name: string(),

  bank_validated: boolean().test(
    "bank-validated-required",
    "Please validate bank details before submitting",
    function (value) {
      const { bank_name, bank_account_number, ifsc_code, beneficiary_name } =
        this.parent;

      const hasBankDetails =
        bank_name || bank_account_number || ifsc_code || beneficiary_name;

      // If no bank details - allow submit
      if (!hasBankDetails) return true;

      //  Bank details present - must be validated
      return value === true;
    },
  ),
  // outlet_verified: boolean().test(
  //   "outlet-verified-required",
  //   "Please verify the business outlet image before updating",
  //   function (value) {
  //     const { docMap } = this.options.context || {};
  //     if (docMap?.business_outlet_image?.file_path) {
  //       return value === true; // must be checked
  //     }
  //     return true; // no image - no validation
  //   }
  // ),
});

export const EditPersonalDetails = ({ id }) => {
  const [loading, setLoading] = useState(false);
  const [docMap, setDocMap] = useState({});
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  // const [imageUrl, setImageUrl] = useState("");
  const [previewFile, setPreviewFile] = useState({
    url: "",
    type: "", // "image" | "pdf" | "unsupported"
  });

  const [wholesaler, setWholesaler] = useState(null);
  const [toggleModalOpenVerification, setToggleModalOpenVerification] =
    useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);
  // reupload
  const [reuploadMode, setReuploadMode] = useState({});

  const navigate = useNavigate();

  console.log(id);

  const [ryderZoneList, setRyderZoneList] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);

  const fetchRyderZone = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/admin/ryder-zone-list/");

      if (res.data.status === "success") {
        const data = res.data.data || [];

        setRyderZoneList(data);

        // Extract unique cities
        const uniqueCities = [...new Set(data.map((item) => item.city))];

        // Convert for react-select
        const formattedCities = uniqueCities.map((city) => ({
          value: city,
          label: city,
        }));

        setCityOptions(formattedCities);
      }
    } catch (err) {
      console.error("Error fetching RyderZone data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRyderZone();
  }, []);

  const renameFile = (file, username, key) => {
    const ext = file.name.split(".").pop();
    const newName = `${username}_${key}.${ext}`;
    return new File([file], newName, { type: file.type });
  };

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      alternative_contact_number: "",
      door_no: "",
      street: "",
      area: "",
      city: "",
      state: "",
      pincode: "",
      ryder_zone: "",

      business_name: "",
      bank_name: "",
      ifsc_code: "",
      beneficiary_name: "",
      bank_account_number: "",
      competent_person_name: "",
      qualification: "",
      razorpay_account_id: "",
      registered_number: "",
      form20a_verified: false,
      form21a_verified: false,
      gst_verified: false,
      aadhaar_verified: false,
      pan_verified: false,
      outlet_verified: false,

      is_registered: false,
      is_verified: false,
      is_active: false,
      bank_validated: false,

      /** NEW: file upload fields */
      form_20a_file: null,
      form_21a_file: null,
      gst_certificate_file: null,
      aadhaar_file: null,
      pan_card_file: null,
      business_outlet_image_file: null,
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      //  BLOCK IF BUSINESS OUTLET IMAGE EXISTS BUT NOT VERIFIED
      // if (docMap?.business_outlet_image?.file_path && !values.outlet_verified) {
      //   formik.setFieldError(
      //     "outlet_verified",
      //     "Please verify the business outlet image before submitting",
      //   );

      //   formik.setFieldTouched("outlet_verified", true, false);

      //   setLoading(false);
      //   return;
      // }
      // BLOCK IF BUSINESS OUTLET IMAGE AND IS_VERIFIED NOT EXIT
      const hasExistingOutletImage = Boolean(
        docMap?.business_outlet_image?.file_path,
      );

      const hasNewOutletImage = Boolean(values.business_outlet_image_file);
      // business outlet image
      if (!hasExistingOutletImage && !hasNewOutletImage) {
        formik.setFieldError(
          "business_outlet_image_file",
          "Business outlet image is required",
        );

        formik.setFieldTouched("business_outlet_image_file", true, false);

        setLoading(false);
        return;
      }
      // is verfied
      if (
        (hasExistingOutletImage || hasNewOutletImage) &&
        !values.outlet_verified
      ) {
        formik.setFieldError(
          "outlet_verified",
          "Please verify the business outlet image before submitting",
        );

        formik.setFieldTouched("outlet_verified", true, false);

        setLoading(false);
        return;
      }
      try {
        const docKeys = [
          "form_20a",
          "form_21a",
          "gst_certificate",
          "aadhaar",
          "pan_card",
          "business_outlet_image",
        ];

        const uploadedDocs = docKeys.filter((key) => values[`${key}_file`]);
        const hasFileUpload = uploadedDocs.length > 0;

        /**
         * =====================================================
         * CASE 1 — NO FILE UPLOAD → NORMAL PUT JSON
         * =====================================================
         */
        if (!hasFileUpload) {
          const businessDocsPayload = docKeys
            .filter((key) => docMap[key]?.businessdoc_id)
            .map((key) => ({
              businessdoc_id: docMap[key].businessdoc_id,
              is_verified:
                values[
                  key === "form_20a"
                    ? "form20a_verified"
                    : key === "form_21a"
                      ? "form21a_verified"
                      : key === "gst_certificate"
                        ? "gst_verified"
                        : key === "aadhaar"
                          ? "aadhaar_verified"
                          : key === "pan_card"
                            ? "pan_verified"
                            : "outlet_verified"
                ],
            }));

          const jsonPayload = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            alternative_contact_number: values.alternative_contact_number,
            door_no: values.door_no,
            street: values.street,
            area: values.area,
            city: values.city,
            state: values.state,
            pincode: values.pincode,
            ryder_zone: values.ryder_zone,

            bank_name: values.bank_name,
            ifsc_code: values.ifsc_code,
            bank_account_number: values.bank_account_number,
            razorpay_account_id: values.razorpay_account_id,
            beneficiary_name: values.beneficiary_name,

            wholesalers: {
              business_name: values.business_name,
              competent_person_name: values.competent_person_name,
              qualification: values.qualification,
              registered_number: values.registered_number,
            },

            is_registered: values.is_registered,
            is_verified: values.is_verified,
            is_active: values.is_active,
            bank_validated: values.bank_validated,

            business_docs: businessDocsPayload,
          };

          const response = await axiosInstance.put(
            `/admin/wholesaler-list/${id}/`,
            jsonPayload,
          );

          if (response.data.status === "success") {
            toast.success("Wholesaler updated successfully!");
            setTimeout(() => navigate("/manage-wholesaler"), 1500);
          }

          setLoading(false);
          return;
        }

        /**
         * =====================================================
         * CASE 2 — SEQUENTIAL FILE UPLOAD (ONE BY ONE)
         * =====================================================
         */

        for (let i = 0; i < uploadedDocs.length; i++) {
          const key = uploadedDocs[i];
          const existingDoc = docMap[key];
          const originalFile = values[`${key}_file`];

          // 🔹 Rename file
          const renamedFile = renameFile(
            originalFile,
            values.username || wholesaler?.username,
            key,
          );

          const formData = new FormData();

          if (existingDoc?.businessdoc_id) {
            formData.append(
              "business_docs[0][businessdoc_id]",
              existingDoc.businessdoc_id,
            );
          }

          formData.append("business_docs[0][file_name]", key);
          formData.append("business_docs[0][file_path]", renamedFile);

          const patchResponse = await axiosInstance.patch(
            `/admin/wholesaler-list/${id}/`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          );

          if (patchResponse.data.status !== "success") {
            toast.error(`Failed to upload ${key}`);
            setLoading(false);
            return;
          }
        }

        /**
         * =====================================================
         * CASE 3 — FINAL PUT JSON (AFTER ALL FILES UPLOADED)
         * =====================================================
         */

        const businessDocsPayload = docKeys
          .filter((key) => docMap[key]?.businessdoc_id)
          .map((key) => ({
            businessdoc_id: docMap[key].businessdoc_id,
            is_verified:
              values[
                key === "form_20a"
                  ? "form20a_verified"
                  : key === "form_21a"
                    ? "form21a_verified"
                    : key === "gst_certificate"
                      ? "gst_verified"
                      : key === "aadhaar"
                        ? "aadhaar_verified"
                        : key === "pan_card"
                          ? "pan_verified"
                          : "outlet_verified"
              ],
          }));

        const finalJsonPayload = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          alternative_contact_number: values.alternative_contact_number,
          door_no: values.door_no,
          street: values.street,
          area: values.area,
          city: values.city,
          state: values.state,
          pincode: values.pincode,
          ryder_zone: values.ryder_zone,

          bank_name: values.bank_name,
          ifsc_code: values.ifsc_code,
          bank_account_number: values.bank_account_number,
          razorpay_account_id: values.razorpay_account_id,
          beneficiary_name: values.beneficiary_name,

          wholesalers: {
            business_name: values.business_name,
            competent_person_name: values.competent_person_name,
            qualification: values.qualification,
            registered_number: values.registered_number,
          },

          is_registered: values.is_registered,
          is_verified: values.is_verified,
          is_active: values.is_active,
          bank_validated: values.bank_validated,

          business_docs: businessDocsPayload,
        };

        const putResponse = await axiosInstance.put(
          `/admin/wholesaler-list/${id}/`,
          finalJsonPayload,
        );

        if (putResponse.data.status === "success") {
          toast.success("Wholesaler updated successfully!");
          setTimeout(() => navigate("/manage-wholesaler"), 1500);
        }
      } catch (err) {
        console.error("ERR:", err);
        toast.error("Something went wrong.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    navigate("/manage-wholesaler");
  };

  useEffect(() => {
    const fetchWholesalerDetails = async () => {
      try {
        const res = await axiosInstance.get(`/admin/wholesaler-list/${id}`);
        if (res.data.status === "success" && res.data.data) {
          const data = res.data.data;

          setWholesaler(data);
          const docs = data.business_docs || [];
          const docObject = {};
          docs.forEach((doc) => {
            docObject[doc.file_name] = doc;
          });
          setDocMap(docObject); // ⬅️ Store for preview/buttons etc.
          // Set Formik values
          formik.setValues({
            first_name: data.first_name || "",
            last_name: data.last_name || "",
            email: data.email || "",
            mobile_no: data.mobile_no || "",
            alternative_contact_number: data.alternative_contact_number || "",
            door_no: data.door_no || "",
            street: data.street || "",
            area: data.area || "",
            city: data.city || "",
            state: data.state || "",
            pincode: data.pincode || "",
            ryder_zone: data.ryder_zone || "",
            business_name: data.wholesalers?.business_name || "",
            bank_name: data.bank_name || "",
            ifsc_code: data.ifsc_code || "",
            bank_account_number: data.bank_account_number || "",
            razorpay_account_id: data.razorpay_account_id || "",
            beneficiary_name: data.beneficiary_name || "",
            competent_person_name:
              data.wholesalers?.competent_person_name || "",
            qualification: data.wholesalers?.qualification || "",
            registered_number: data.wholesalers?.registered_number || "",

            // 🆕 Set verification flags from document map
            form20a_verified: docObject["form_20a"]?.is_verified || false,
            form21a_verified: docObject["form_21a"]?.is_verified || false,
            gst_verified: docObject["gst_certificate"]?.is_verified || false,
            aadhaar_verified: docObject["aadhaar"]?.is_verified || false,
            pan_verified: docObject["pan_card"]?.is_verified || false,
            outlet_verified:
              docObject["business_outlet_image"]?.is_verified || false,
            is_registered: data.is_registered,
            is_verified: data.is_verified,
            is_active: data.is_active,
            bank_validated: data.bank_validated,
          });
        } else {
          toast.error("Failed to load wholesaler details.");
          setDocMap({});
        }
      } catch (err) {
        console.error("Error fetching wholesaler data:", err);
        toast.error("Something went wrong while loading wholesaler data.");
        setDocMap({});
      }
    };

    fetchWholesalerDetails();
  }, [id]);

  const handleToggleStatus = () => {
    if (!toggleTarget) return;
    formik.setFieldValue(toggleTarget.field, !toggleTarget.currentValue);
    setToggleModalOpenVerification(false);
    setToggleTarget(null);
  };

  if (loading) return <p>Loading wholesaler details...</p>;
  // if (!wholesaler) return <p>No wholesaler data found.</p>;

  const formatDate = (dateString) => {
    if (!dateString) return "--";
    const date = new Date(dateString);
    if (isNaN(date)) return "--"; // handle invalid date
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getFileType = (url = "") => {
    const extension = url.split(".").pop()?.toLowerCase();

    if (["jpg", "jpeg", "png", "webp"].includes(extension)) return "image";
    if (extension === "pdf") return "pdf";

    return "unsupported";
  };

  const openPreview = (filePath) => {
    if (!filePath) return;

    setPreviewFile({
      url: filePath,
      type: getFileType(filePath),
    });

    setToggleModalOpen(true);
  };

  return (
    <>
      <div className="editWholesaler-container">
        <form onSubmit={formik.handleSubmit}>
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">General Information</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>First Name
                </label>
                <div>
                  <input
                    type="text"
                    name="first_name"
                    placeholder="Enter Your First Name"
                    value={formik.values.first_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.first_name && formik.errors.first_name && (
                    <div className="text-danger">
                      {formik.errors.first_name}
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="editWholesaler-field">
            <label>
              <span className="text-danger">*</span>Create Password
            </label>
            <div>
              <input type="text" placeholder="Enter New Password" />
            </div>
          </div> */}

              <div className="editWholesaler-field">
                <label>Mobile Number</label>
                <div>
                  <input
                    type="tel"
                    name="mobile_no"
                    placeholder="Enter Your mobile_no"
                    value={formik.values.mobile_no}
                    onBlur={formik.handleBlur}
                    maxLength={10}
                    disabled
                  />
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>
                  {" "}
                  <span className="text-danger">*</span>Alternative Contact
                  Number
                </label>
                <div>
                  <input
                    type="tel"
                    name="alternative_contact_number"
                    placeholder="Enter Your Alternative Contact Number"
                    value={formik.values.alternative_contact_number}
                    onChange={(e) => {
                      const input = e.target.value;
                      // Only allow digits and max 10 characters
                      if (/^\d{0,10}$/.test(input)) {
                        formik.setFieldValue(
                          "alternative_contact_number",
                          input,
                        );
                      }
                    }}
                    onBlur={formik.handleBlur}
                    maxLength={10}
                  />
                  {formik.touched.alternative_contact_number &&
                    formik.errors.alternative_contact_number && (
                      <div className="text-danger">
                        {formik.errors.alternative_contact_number}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="general-right">
              <div className="editWholesaler-field">
                <label>Last Name</label>
                <div>
                  <input
                    type="text"
                    name="last_name"
                    placeholder="Enter Your Last Name"
                    value={formik.values.last_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Email id
                </label>
                <div>
                  <input
                    type="text"
                    name="email"
                    placeholder="Enter Your email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-danger">{formik.errors.email}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* address */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Address</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Door No/House No
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Door No/House No"
                    name="door_no"
                    value={formik.values.door_no}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.door_no && formik.errors.door_no && (
                    <div className="text-danger">{formik.errors.door_no}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Area/Locality
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Area"
                    name="area"
                    value={formik.values.area}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.area && formik.errors.area && (
                    <div className="text-danger">{formik.errors.area}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>City/Town
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your City"
                    name="city"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.city && formik.errors.city && (
                    <div className="text-danger">{formik.errors.city}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Ryder Zone
                </label>
                <Select
                  options={cityOptions}
                  value={
                    cityOptions.find(
                      (option) => option.value === formik.values.ryder_zone,
                    ) || null
                  }
                  onChange={(option) => {
                    formik.setFieldValue("ryder_zone", option?.value || "");
                  }}
                  onBlur={() => formik.setFieldTouched("ryder_zone", true)}
                  placeholder="Search Ryder Zone"
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "35px",
                      height: "35px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: "35px",
                      padding: "0 8px",
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: "35px",
                    }),
                  }}
                />
                {formik.touched.ryder_zone && formik.errors.ryder_zone && (
                  <div className="text-danger">{formik.errors.ryder_zone}</div>
                )}
              </div>
            </div>
            <div className="general-right">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Street
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Street"
                    name="street"
                    value={formik.values.street}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.street && formik.errors.street && (
                    <div className="text-danger">{formik.errors.street}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>State
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your State"
                    name="state"
                    value={formik.values.state}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.state && formik.errors.state && (
                    <div className="text-danger">{formik.errors.state}</div>
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Pincode
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Pincode"
                    name="pincode"
                    value={formik.values.pincode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.pincode && formik.errors.pincode && (
                    <div className="text-danger">{formik.errors.pincode}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Business Information */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Business Information</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <label>
                  <span className="text-danger">*</span>Business Name
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Business Name "
                    name="business_name"
                    value={formik.values.business_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.business_name &&
                    formik.errors.business_name && (
                      <div className="text-danger">
                        {formik.errors.business_name}
                      </div>
                    )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>Form 20A</label>

                  {/* Reupload Icon (Appears only when file exists) */}
                  {docMap["form_20a"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["form_20a"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          form_20a: !prev["form_20a"],
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {/* If file exists AND reupload mode is OFF */}
                  {docMap["form_20a"]?.file_path &&
                  !reuploadMode["form_20a"] ? (
                    <div>
                      {/* Preview button */}
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(docMap["form_20a"]?.file_path || "");
                        //   setToggleModalOpen(true);
                        // }}

                        onClick={() =>
                          openPreview(docMap["form_20a"]?.file_path)
                        }
                      >
                        Preview the document
                      </button>

                      <div className="mt-2 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="form20a_verified"
                          checked={formik.values.form20a_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>

                      <div className="licenseExpiryDate">
                        <p>
                          <b>License Expiry Date</b>:{" "}
                          {docMap["form_20a"]?.license_expiry_date
                            ? formatDate(docMap["form_20a"].license_expiry_date)
                            : "--"}
                        </p>
                      </div>
                    </div>
                  ) : (
                    // Show upload file input when:
                    // 1. file_path is null OR
                    // 2. user clicked the reupload icon
                    <input
                      type="file"
                      onChange={(e) =>
                        formik.setFieldValue("form_20a_file", e.target.files[0])
                      }
                    />
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>
                    <span className="text-danger">*</span>Business Outlet Image
                  </label>

                  {docMap["business_outlet_image"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["business_outlet_image"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          business_outlet_image: !prev["business_outlet_image"],
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {docMap["business_outlet_image"]?.file_path &&
                  !reuploadMode["business_outlet_image"] ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(
                        //     docMap["business_outlet_image"].file_path
                        //   );
                        //   setToggleModalOpen(true);
                        // }}
                        onClick={() =>
                          openPreview(
                            docMap["business_outlet_image"]?.file_path,
                          )
                        }
                      >
                        Preview the document
                      </button>

                      <div className="licenseExpiryDate">
                        <p>
                          <b>License Expiry Date</b>:{" "}
                          {docMap["business_outlet_image"].license_expiry_date
                            ? formatDate(
                                docMap["business_outlet_image"]
                                  .license_expiry_date,
                              )
                            : "--"}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <>
                      <input
                        type="file"
                        onChange={(e) =>
                          formik.setFieldValue(
                            "business_outlet_image_file",
                            e.target.files[0],
                          )
                        }
                      />
                      {formik.touched.business_outlet_image_file &&
                        formik.errors.business_outlet_image_file && (
                          <div className="text-danger">
                            {formik.errors.business_outlet_image_file}
                          </div>
                        )}
                    </>
                  )}
                </div>
                {/* CHECKBOX FOR BOTH EXISTING AND NEWLY SELECTED IMAGE */}
                <div className="mt-2 ">
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      name="outlet_verified"
                      checked={formik.values.outlet_verified}
                      onChange={formik.handleChange}
                    />
                    <span className="textIsverified">Is Verified</span>
                  </div>
                  <div>
                    {(formik.touched.outlet_verified ||
                      formik.submitCount > 0) &&
                      formik.errors.outlet_verified && (
                        <div className="text-danger">
                          {formik.errors.outlet_verified}
                        </div>
                      )}
                  </div>
                </div>
              </div>
              {/* <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>License Expiry Date
              </label>
              <div>
                <input type="date" />
                <div>
                  <span>
                    <input type="checkbox" />
                  </span>
                  <span className="textIsverified">Is Verified</span>
                </div>
              </div>
            </div> */}
            </div>
            <div className="general-right">
              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>GST</label>

                  {docMap["gst_certificate"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["gst_certificate"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          gst_certificate: !prev["gst_certificate"],
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {docMap["gst_certificate"]?.file_path &&
                  !reuploadMode["gst_certificate"] ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(docMap["gst_certificate"].file_path);
                        //   setToggleModalOpen(true);
                        // }}
                        onClick={() =>
                          openPreview(docMap["gst_certificate"]?.file_path)
                        }
                      >
                        Preview the document
                      </button>

                      <div className="mt-2 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="gst_verified"
                          checked={formik.values.gst_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>

                      <div className="licenseExpiryDate">
                        <p>
                          <b>License Expiry Date</b>:{" "}
                          {docMap["gst_certificate"].license_expiry_date
                            ? formatDate(
                                docMap["gst_certificate"].license_expiry_date,
                              )
                            : "--"}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <input
                      type="file"
                      onChange={(e) =>
                        formik.setFieldValue(
                          "gst_certificate_file",
                          e.target.files[0],
                        )
                      }
                    />
                  )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>Form 21A</label>

                  {docMap["form_21a"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["form_21a"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          form_21a: !prev["form_21a"],
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {docMap["form_21a"]?.file_path &&
                  !reuploadMode["form_21a"] ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(docMap["form_21a"].file_path);
                        //   setToggleModalOpen(true);
                        // }}

                        onClick={() =>
                          openPreview(docMap["form_21a"]?.file_path)
                        }
                      >
                        Preview the document
                      </button>

                      <div className="mt-2 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="form21a_verified"
                          checked={formik.values.form21a_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>

                      <div className="licenseExpiryDate">
                        <p>
                          <b>License Expiry Date</b>:{" "}
                          {docMap["form_21a"].license_expiry_date
                            ? formatDate(docMap["form_21a"].license_expiry_date)
                            : "--"}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <input
                      type="file"
                      onChange={(e) =>
                        formik.setFieldValue("form_21a_file", e.target.files[0])
                      }
                    />
                  )}
                </div>
              </div>

              {/* <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>License Start Date
              </label>
              <div>
                <input type="date" />
                <div>
                  <span>
                    <input type="checkbox" />
                  </span>
                  <span className="textIsverified">Is Verified</span>
                </div>
              </div>
            </div> */}
            </div>
          </div>
          {/* KYC Information */}
          <div className="editWholesaler-subcontainer">
            <span className="edit-title">KYC:</span>
          </div>
          <div className="general-container">
            <div className="general-left">
              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>PAN Card</label>

                  {docMap["pan_card"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["pan_card"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          pan_card: !prev["pan_card"],
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {docMap["pan_card"]?.file_path &&
                  !reuploadMode["pan_card"] ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(docMap["pan_card"].file_path);
                        //   setToggleModalOpen(true);
                        // }}

                        onClick={() =>
                          openPreview(docMap["pan_card"]?.file_path)
                        }
                      >
                        Preview the document
                      </button>

                      <div className="mt-2 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="pan_verified"
                          checked={formik.values.pan_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>

                      <div className="licenseExpiryDate">
                        <p>
                          <b>License Expiry Date</b>:{" "}
                          {docMap["pan_card"].license_expiry_date
                            ? formatDate(docMap["pan_card"].license_expiry_date)
                            : "--"}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <input
                      type="file"
                      onChange={(e) =>
                        formik.setFieldValue("pan_card_file", e.target.files[0])
                      }
                    />
                  )}
                </div>
              </div>
              <div className="editWholesaler-field mt-4">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  Bank Name
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Bank Name"
                    name="bank_name"
                    value={formik.values.bank_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.bank_name && formik.errors.bank_name && (
                    <div className="text-danger">{formik.errors.bank_name}</div>
                  )}
                </div>
                <div className="editWholesaler-field">
                  <label>Competent Person Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Competent Person Number"
                      name="competent_person_name"
                      value={formik.values.competent_person_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="editWholesaler-field">
                  <label>Registered Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Your Registered Number"
                      name="registered_number"
                      value={formik.values.registered_number}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="editWholesaler-field">
                  <label>
                    {/* <span className="text-danger">*</span> */}
                    IFSC Code
                  </label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Your ifsc code"
                      name="ifsc_code"
                      value={formik.values.ifsc_code}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.ifsc_code && formik.errors.ifsc_code && (
                      <div className="text-danger">
                        {formik.errors.ifsc_code}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="general-right">
              <div className="editWholesaler-field">
                <div className="doc-label-wrapper">
                  <label>Aadhaar Card</label>

                  {docMap["aadhaar"]?.file_path && (
                    <div
                      className={`reupload-icon ${
                        reuploadMode["aadhaar"] ? "active" : ""
                      }`}
                      onClick={() =>
                        setReuploadMode((prev) => ({
                          ...prev,
                          aadhaar: !prev["aadhaar"],
                        }))
                      }
                      title="Re-upload document"
                    >
                      ↻
                    </div>
                  )}
                </div>

                <div>
                  {docMap["aadhaar"]?.file_path && !reuploadMode["aadhaar"] ? (
                    <div>
                      <button
                        type="button"
                        className="preview-button"
                        // onClick={() => {
                        //   setImageUrl(docMap["aadhaar"].file_path);
                        //   setToggleModalOpen(true);
                        // }}

                        onClick={() =>
                          openPreview(docMap["aadhaar"]?.file_path)
                        }
                      >
                        Preview the document
                      </button>

                      <div className="mt-2 d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          name="aadhaar_verified"
                          checked={formik.values.aadhaar_verified}
                          onChange={formik.handleChange}
                        />
                        <span className="textIsverified">Is Verified</span>
                      </div>

                      <div className="licenseExpiryDate">
                        <p>
                          <b>License Expiry Date</b>:{" "}
                          {docMap["aadhaar"].license_expiry_date
                            ? formatDate(docMap["aadhaar"].license_expiry_date)
                            : "--"}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <input
                      type="file"
                      onChange={(e) =>
                        formik.setFieldValue("aadhaar_file", e.target.files[0])
                      }
                    />
                  )}
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  Bank Account Number
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Bank Account Number"
                    name="bank_account_number"
                    value={formik.values.bank_account_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.bank_account_number &&
                    formik.errors.bank_account_number && (
                      <div className="text-danger">
                        {formik.errors.bank_account_number}
                      </div>
                    )}
                </div>
              </div>
              <div className="editWholesaler-field">
                <label>Qualification</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your Qualification"
                    name="qualification"
                    value={formik.values.qualification}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  Razorpay Account ID
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your razorpay account id"
                    name="razorpay_account_id"
                    value={formik.values.razorpay_account_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.razorpay_account_id &&
                    formik.errors.razorpay_account_id && (
                      <div className="text-danger">
                        {formik.errors.razorpay_account_id}
                      </div>
                    )}
                </div>
              </div>

              <div className="editWholesaler-field">
                <label>
                  {/* <span className="text-danger">*</span> */}
                  Account Holder Name
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Your benefiiary name"
                    name="beneficiary_name"
                    value={formik.values.beneficiary_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.beneficiary_name &&
                    formik.errors.beneficiary_name && (
                      <div className="text-danger">
                        {formik.errors.beneficiary_name}
                      </div>
                    )}
                </div>
              </div>
            </div>

            <div className="editWholesaler-field">
              <label>IS Bank Validated</label>
              <div
                className="form-check form-switch"
                style={{ marginTop: "5px" }}
              >
                <input
                  type="checkbox"
                  className="form-check-input form-check-input-verification"
                  checked={formik.values.bank_validated}
                  onChange={() => {
                    setToggleTarget({
                      field: "bank_validated",
                      currentValue: formik.values.bank_validated,
                    });
                    setToggleModalOpenVerification(true);
                  }}
                />
              </div>
              <div>
                {formik.errors.bank_validated && (
                  <div className="text-danger">
                    {formik.errors.bank_validated}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="editWholesaler-subcontainer">
            <span className="edit-title">Wholesaler Verification</span>
          </div>

          <div className="general-container">
            <div className="general-left">
              {/* IS Registered */}
              <div className="editWholesaler-field">
                <label>IS Registered</label>
                <div
                  className="form-check form-switch"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input form-check-input-verification"
                    checked={formik.values.is_registered}
                    onChange={() => {
                      setToggleTarget({
                        field: "is_registered",
                        currentValue: formik.values.is_registered,
                      });
                      setToggleModalOpenVerification(true);
                    }}
                  />
                </div>
              </div>

              {/* IS Verified */}
              <div className="editWholesaler-field">
                <label>IS Verified</label>
                <div
                  className="form-check form-switch"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input form-check-input-verification"
                    checked={formik.values.is_verified}
                    onChange={() => {
                      setToggleTarget({
                        field: "is_verified",
                        currentValue: formik.values.is_verified,
                      });
                      setToggleModalOpenVerification(true);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="general-right">
              {/* IS Active */}
              <div className="editWholesaler-field">
                <label>IS Active</label>
                <div
                  className="form-check form-switch"
                  style={{ marginTop: "5px" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input form-check-input-verification"
                    checked={formik.values.is_active}
                    onChange={() => {
                      setToggleTarget({
                        field: "is_active",
                        currentValue: formik.values.is_active,
                      });
                      setToggleModalOpenVerification(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="general-container">
            <div className="general-left">
              <div>
                <button
                  type="button"
                  className="admin-btnCancel"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="general-right">
              <div>
                <button className="whole-btnUpdate" disabled={loading}>
                  {loading ? "Updateing..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* <Modal
        open={toggleModalOpen}
        onClose={() => setToggleModalOpen(false)}
        aria-labelledby="toggle-status-title"
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <button
            onClick={() => setToggleModalOpen(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">Preview the document</h3>
          <hr />
          <div style={{ textAlign: "center" }}>
            {imageUrl ? (
              <img
                src={imageUrl || NoImageFound}
                alt="Document"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NoImageFound;
                }}
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            ) : (
              <div>No document to display.</div>
            )}
          </div>
          <hr />
        </Box>
      </Modal> */}

      <Modal
        open={toggleModalOpen}
        onClose={() => setToggleModalOpen(false)}
        aria-labelledby="toggle-status-title"
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: 600,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* Close Button */}
          <button
            onClick={() => setToggleModalOpen(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">Preview the document</h3>
          <hr />

          <div style={{ textAlign: "center" }}>
            {/* 🖼 IMAGE PREVIEW */}
            {previewFile.type === "image" && (
              <img
                src={previewFile.url}
                alt="Document"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NoImageFound;
                }}
                style={{
                  width: "100%",
                  maxHeight: "450px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            )}

            {/* 📄 PDF PREVIEW */}
            {previewFile.type === "pdf" && (
              <iframe
                src={previewFile.url}
                title="PDF Preview"
                width="100%"
                height="500px"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            )}

            {/* ❌ UNSUPPORTED */}
            {previewFile.type === "unsupported" && (
              <p style={{ color: "#888" }}>
                Preview not available for this file type.
              </p>
            )}
          </div>

          <hr />

          {/* Optional open in new tab */}
          {previewFile.url && (
            <div style={{ textAlign: "right" }}>
              <a
                href={previewFile.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontWeight: 600, textDecoration: "none" }}
              >
                Open in new tab
              </a>
            </div>
          )}
        </Box>
      </Modal>

      <Dialog
        open={toggleModalOpenVerification}
        onClose={() => setToggleModalOpenVerification(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Are you sure?
          <IconButton
            aria-label="close"
            onClick={() => setToggleModalOpenVerification(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {toggleTarget && (
            <Typography>
              Do you want to{" "}
              <strong>
                {toggleTarget.currentValue ? "DISABLE" : "ENABLE"}
              </strong>{" "}
              <code>{toggleTarget.field}</code> for this Wholesaler?
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setToggleModalOpenVerification(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleToggleStatus}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
